import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 21.018c0 1.08-.895 1.956-2 1.956s-2-.876-2-1.956.895-1.955 2-1.955 2 .876 2 1.955m11 0c0 1.08-.895 1.956-2 1.956s-2-.876-2-1.956.895-1.955 2-1.955 2 .876 2 1.955m1.8-15.25c-.2-.293-.5-.391-.8-.391H6.8L6 1.271C5.9.782 5.5.49 5 .49H1c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h3.2L5 6.55v.098l1.7 8.114a2.97 2.97 0 0 0 2.9 2.346h9.8c1.5 0 2.7-.978 3-2.346L24 6.55c0-.293 0-.586-.2-.782m-3.4 8.603c-.1.489-.5.782-1 .782H9.7c-.5 0-.9-.293-1-.782L7.2 7.332h14.6z"
    }, null, -1)
  ]))]))
}
export default { render: render }